import { createSvgIcon } from '@mui/material/utils'

const NewFeatures = createSvgIcon(
  <>
    <g clipPath="url(#clip0_6458_409330)" fill="none">
      <path
        d="M0.780701 93.1174H124.735C124.735 96.8352 121.714 99.8568 117.996 99.8568H7.5201C3.80229 99.8568 0.780701 96.8352 0.780701 93.1174Z"
        stroke="#204ECF"
        strokeWidth="1.39244"
        strokeLinejoin="round"
      />
      <path
        d="M45.8419 14.3889C63.1638 -2.93302 91.2631 -2.93302 108.585 14.3889C125.907 31.7108 125.907 59.8102 108.585 77.1321L45.8419 14.3889Z"
        stroke="#204ECF"
        strokeWidth="1.39244"
        strokeLinejoin="round"
      />
      <path
        d="M64.4034 11.5895C77.3809 6.74379 92.5724 9.52866 103.002 19.9719"
        stroke="#204ECF"
        strokeWidth="1.39244"
        strokeLinejoin="round"
      />
      <path
        d="M112.345 16.3381C114.459 16.3381 116.174 14.6237 116.174 12.5089C116.174 10.3941 114.459 8.67969 112.345 8.67969C110.23 8.67969 108.515 10.3941 108.515 12.5089C108.515 14.6237 110.23 16.3381 112.345 16.3381Z"
        stroke="#204ECF"
        strokeWidth="1.39244"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_6458_409330">
        <rect
          width="125.347"
          height="99.8516"
          fill="white"
          transform="translate(0.085083 0.700928)"
        />
      </clipPath>
    </defs>
  </>,
  'NewFeatures'
)

export default NewFeatures
